export default "__VITE_ASSET__1CXWAWs___"